import React, { useEffect, useState } from "react";
import Header from "../../Core/Header";
import { holidayAddApi, holidayList } from "../../Services/Operations/ProductAPI";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

const Holiday = () => {
  const token = useSelector((state) => state.user.token);
  console.log("token : ", token);
  const [holiday, setHoliday] = useState([]);
  const [formData, setFormData] = useState({
    holidayName: "",
    holidayDate: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.holidayName || !formData.holidayDate) {
      toast.error("All fields are required!");
      return;
    }

    try {
      const response = await holidayAddApi(formData, token);
      console.log("Holiday Added Response:", response);

      if (response.status === 200) {
        toast.success("Holiday added successfully!");
        setFormData({ holidayName: "", holidayDate: "" });
      } else {
        toast.error(response.data.errors?.message || "Failed to add holiday.");
      }
    } catch (error) {
      console.error("Error adding holiday:", error);
      toast.error("An error occurred. Please try again.");
    }
  };

  useEffect(() => {
    const fetchHolidayList = async () => {
      try {
        const response = await holidayList(token);
        console.log("holiday : ", response);
        setHoliday(response.data);
      } catch (error) {
        console.error("Error:", error);
      }
    };

    fetchHolidayList();
  }, []);

  return (
    <div>
      <div id="main_content">
        <Header />
        <div className="page">
          {/* <Section /> */}
          <div className="section-body" id="page_top">
            <div className="container-fluid">
              <div className="page-header">
                <div>
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="What you want to find"
                    />
                    <div className="input-group-append">
                      <button
                        className="btn btn-outline-secondary"
                        type="button"
                      >
                        Search
                      </button>
                    </div>
                  </div>
                </div>
                <div className="right">
                  <ul className="nav nav-pills">
                    <li className="nav-item dropdown">
                      <a
                        className="nav-link dropdown-toggle"
                        data-toggle="dropdown"
                        href="#"
                        role="button"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        Pages
                      </a>
                      <div className="dropdown-menu">
                        <a className="dropdown-item" href="page-empty.html">
                          Empty page
                        </a>
                        <a className="dropdown-item" href="page-profile.html">
                          Profile
                        </a>
                        <a className="dropdown-item" href="page-search.html">
                          Search Results
                        </a>
                        <a className="dropdown-item" href="page-timeline.html">
                          Timeline
                        </a>
                        <a className="dropdown-item" href="page-invoices.html">
                          Invoices
                        </a>
                        <a className="dropdown-item" href="page-pricing.html">
                          Pricing
                        </a>
                      </div>
                    </li>
                    <li className="nav-item dropdown">
                      <a
                        className="nav-link dropdown-toggle"
                        data-toggle="dropdown"
                        href="#"
                        role="button"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        Auth
                      </a>
                      <div className="dropdown-menu">
                        <a className="dropdown-item" href="login.html">
                          Login
                        </a>
                        <a className="dropdown-item" href="register.html">
                          Register
                        </a>
                        <a
                          className="dropdown-item"
                          href="forgot-password.html"
                        >
                          Forgot password
                        </a>
                        <div className="dropdown-divider" />
                        <a className="dropdown-item" href="404.html">
                          404 error
                        </a>
                        <a className="dropdown-item" href="500.html">
                          500 error
                        </a>
                      </div>
                    </li>
                  </ul>
                  <div className="notification d-flex">
                    <div className="dropdown d-flex">
                      <a
                        className="nav-link icon d-none d-md-flex btn btn-default btn-icon ml-1"
                        data-toggle="dropdown"
                      >
                        <i className="fa fa-language" />
                      </a>
                      <div className="dropdown-menu dropdown-menu-right dropdown-menu-arrow">
                        <a className="dropdown-item" href="#">
                          <img
                            className="w20 mr-2"
                            src="../assets/images/flags/us.svg"
                            alt
                          />
                          English
                        </a>
                        <div className="dropdown-divider" />
                        <a className="dropdown-item" href="#">
                          <img
                            className="w20 mr-2"
                            src="../assets/images/flags/es.svg"
                            alt
                          />
                          Spanish
                        </a>
                        <a className="dropdown-item" href="#">
                          <img
                            className="w20 mr-2"
                            src="../assets/images/flags/jp.svg"
                            alt
                          />
                          japanese
                        </a>
                        <a className="dropdown-item" href="#">
                          <img
                            className="w20 mr-2"
                            src="../assets/images/flags/bl.svg"
                            alt
                          />
                          France
                        </a>
                      </div>
                    </div>
                    <div className="dropdown d-flex">
                      <a
                        className="nav-link icon d-none d-md-flex btn btn-default btn-icon ml-1"
                        data-toggle="dropdown"
                      >
                        <i className="fa fa-envelope" />
                        <span className="badge badge-success nav-unread" />
                      </a>
                      <div className="dropdown-menu dropdown-menu-right dropdown-menu-arrow">
                        <ul className="right_chat list-unstyled w350 p-0">
                          <li className="online">
                            <a href="javascript:void(0);" className="media">
                              <img
                                className="media-object"
                                src="../assets/images/xs/avatar4.jpg"
                                alt
                              />
                              <div className="media-body">
                                <span className="name">Donald Gardner</span>
                                <div className="message">
                                  It is a long established fact that a reader
                                </div>
                                <small>11 mins ago</small>
                                <span className="badge badge-outline status" />
                              </div>
                            </a>
                          </li>
                          <li className="online">
                            <a href="javascript:void(0);" className="media">
                              <img
                                className="media-object "
                                src="../assets/images/xs/avatar5.jpg"
                                alt
                              />
                              <div className="media-body">
                                <span className="name">Wendy Keen</span>
                                <div className="message">
                                  There are many variations of passages of Lorem
                                  Ipsum
                                </div>
                                <small>18 mins ago</small>
                                <span className="badge badge-outline status" />
                              </div>
                            </a>
                          </li>
                          <li className="offline">
                            <a href="javascript:void(0);" className="media">
                              <img
                                className="media-object "
                                src="../assets/images/xs/avatar2.jpg"
                                alt
                              />
                              <div className="media-body">
                                <span className="name">Matt Rosales</span>
                                <div className="message">
                                  Contrary to popular belief, Lorem Ipsum is not
                                  simply
                                </div>
                                <small>27 mins ago</small>
                                <span className="badge badge-outline status" />
                              </div>
                            </a>
                          </li>
                          <li className="online">
                            <a href="javascript:void(0);" className="media">
                              <img
                                className="media-object "
                                src="../assets/images/xs/avatar3.jpg"
                                alt
                              />
                              <div className="media-body">
                                <span className="name">Phillip Smith</span>
                                <div className="message">
                                  It has roots in a piece of classical Latin
                                  literature from 45 BC
                                </div>
                                <small>33 mins ago</small>
                                <span className="badge badge-outline status" />
                              </div>
                            </a>
                          </li>
                        </ul>
                        <div className="dropdown-divider" />
                        <a
                          href="javascript:void(0)"
                          className="dropdown-item text-center text-muted-dark readall"
                        >
                          Mark all as read
                        </a>
                      </div>
                    </div>
                    <div className="dropdown d-flex">
                      <a
                        className="nav-link icon d-none d-md-flex btn btn-default btn-icon ml-1"
                        data-toggle="dropdown"
                      >
                        <i className="fa fa-bell" />
                        <span className="badge badge-primary nav-unread" />
                      </a>
                      <div className="dropdown-menu dropdown-menu-right dropdown-menu-arrow">
                        <ul className="list-unstyled feeds_widget">
                          <li>
                            <div className="feeds-left">
                              <span className="avatar avatar-blue">
                                <i className="fa fa-check" />
                              </span>
                            </div>
                            <div className="feeds-body ml-3">
                              <p className="text-muted mb-0">
                                Campaign{" "}
                                <strong className="text-blue font-weight-bold">
                                  Holiday
                                </strong>{" "}
                                is nearly reach budget limit.
                              </p>
                            </div>
                          </li>
                          <li>
                            <div className="feeds-left">
                              <span className="avatar avatar-green">
                                <i className="fa fa-user" />
                              </span>
                            </div>
                            <div className="feeds-body ml-3">
                              <p className="text-muted mb-0">
                                New admission{" "}
                                <strong className="text-green font-weight-bold">
                                  32
                                </strong>{" "}
                                in computer department.
                              </p>
                            </div>
                          </li>
                          <li>
                            <div className="feeds-left">
                              <span className="avatar avatar-red">
                                <i className="fa fa-info" />
                              </span>
                            </div>
                            <div className="feeds-body ml-3">
                              <p className="text-muted mb-0">
                                6th sem result{" "}
                                <strong className="text-red font-weight-bold">
                                  67%
                                </strong>{" "}
                                in computer department.
                              </p>
                            </div>
                          </li>
                          <li>
                            <div className="feeds-left">
                              <span className="avatar avatar-azure">
                                <i className="fa fa-thumbs-o-up" />
                              </span>
                            </div>
                            <div className="feeds-body ml-3">
                              <p className="text-muted mb-0">
                                New Feedback{" "}
                                <strong className="text-azure font-weight-bold">
                                  53
                                </strong>{" "}
                                for RNDSON assessment.
                              </p>
                            </div>
                          </li>
                        </ul>
                        <div className="dropdown-divider" />
                        <a
                          href="javascript:void(0)"
                          className="dropdown-item text-center text-muted-dark readall"
                        >
                          Mark all as read
                        </a>
                      </div>
                    </div>
                    <div className="dropdown d-flex">
                      <a
                        href="javascript:void(0)"
                        className="chip ml-3"
                        data-toggle="dropdown"
                      >
                        <span
                          className="avatar"
                          style={{
                            backgroundImage:
                              "url(../assets/images/xs/avatar5.jpg)",
                          }}
                        />{" "}
                        George
                      </a>
                      <div className="dropdown-menu dropdown-menu-right dropdown-menu-arrow">
                        <a className="dropdown-item" href="page-profile.html">
                          <i className="dropdown-icon fe fe-user" /> Profile
                        </a>
                        <a className="dropdown-item" href="app-setting.html">
                          <i className="dropdown-icon fe fe-settings" />{" "}
                          Settings
                        </a>
                        <a className="dropdown-item" href="app-email.html">
                          <span className="float-right">
                            <span className="badge badge-primary">6</span>
                          </span>
                          <i className="dropdown-icon fe fe-mail" /> Inbox
                        </a>
                        <a className="dropdown-item" href="javascript:void(0)">
                          <i className="dropdown-icon fe fe-send" /> Message
                        </a>
                        <div className="dropdown-divider" />
                        <a className="dropdown-item" href="javascript:void(0)">
                          <i className="dropdown-icon fe fe-help-circle" /> Need
                          help?
                        </a>
                        <a className="dropdown-item" href="login.html">
                          <i className="dropdown-icon fe fe-log-out" /> Sign out
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="section-body">
            <div className="container-fluid">
              <div className="d-flex justify-content-between align-items-center ">
                <div className="header-action">
                  <h1 className="page-title">Holiday</h1>
                  <ol className="breadcrumb page-breadcrumb">
                    <li className="breadcrumb-item">
                      <a href="#">RNDSAN</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Holiday
                    </li>
                  </ol>
                </div>
                <ul className="nav nav-tabs page-header-tab">
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      data-toggle="tab"
                      href="#Holiday-all"
                    >
                      List
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      data-toggle="tab"
                      href="#Holiday-add"
                    >
                      Add
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="section-body mt-4">
            <div className="container-fluid">
              <div className="tab-content">
                <div className="tab-pane active" id="Holiday-Calendar">
                  <div className="card">
                    <div className="card-body">
                      <div id="calendar" />
                    </div>
                  </div>
                </div>
                <div className="tab-pane" id="Holiday-all">
                  <div className="card">
                    <div className="card-body">
                      <div className="table-responsive">
                        {/* <table className="table table-hover table-vcenter text-nowrap js-basic-example dataTable table-striped table_custom border-style spacing5">
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Title</th>
                              <th>Subject</th>
                              <th>Department</th>
                              <th>Year</th>
                              <th>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>1</td>
                              <td>New Year's Day</td>
                              <td>Public Holiday</td>
                              <td>01 January 2024</td>
                              <td>03 January 2024</td>
                              <td>
                                <button
                                  type="button"
                                  className="btn btn-icon btn-sm"
                                  title="View"
                                >
                                  <i className="fa fa-eye" />
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-icon btn-sm"
                                  title="Edit"
                                >
                                  <i className="fa fa-edit" />
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-icon btn-sm js-sweetalert"
                                  title="Delete"
                                  data-type="confirm"
                                >
                                  <i className="fa fa-trash-o text-danger" />
                                </button>
                              </td>
                            </tr>
                            <tr>
                              <td>2</td>
                              <td>Memorial Day</td>
                              <td>Public Holiday</td>
                              <td>29 May 2024</td>
                              <td>29 May 2024</td>
                              <td>
                                <button
                                  type="button"
                                  className="btn btn-icon btn-sm"
                                  title="View"
                                >
                                  <i className="fa fa-eye" />
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-icon btn-sm"
                                  title="Edit"
                                >
                                  <i className="fa fa-edit" />
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-icon btn-sm js-sweetalert"
                                  title="Delete"
                                  data-type="confirm"
                                >
                                  <i className="fa fa-trash-o text-danger" />
                                </button>
                              </td>
                            </tr>
                            <tr>
                              <td>3</td>
                              <td>Christmas Day</td>
                              <td>Public Holiday</td>
                              <td>25 December 2024</td>
                              <td>03 January 2024</td>
                              <td>
                                <button
                                  type="button"
                                  className="btn btn-icon btn-sm"
                                  title="View"
                                >
                                  <i className="fa fa-eye" />
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-icon btn-sm"
                                  title="Edit"
                                >
                                  <i className="fa fa-edit" />
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-icon btn-sm js-sweetalert"
                                  title="Delete"
                                  data-type="confirm"
                                >
                                  <i className="fa fa-trash-o text-danger" />
                                </button>
                              </td>
                            </tr>
                            <tr>
                              <td>4</td>
                              <td>Annual Function</td>
                              <td>Holiday By Collage</td>
                              <td>01 March 2024</td>
                              <td>03 March 2024</td>
                              <td>
                                <button
                                  type="button"
                                  className="btn btn-icon btn-sm"
                                  title="View"
                                >
                                  <i className="fa fa-eye" />
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-icon btn-sm"
                                  title="Edit"
                                >
                                  <i className="fa fa-edit" />
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-icon btn-sm js-sweetalert"
                                  title="Delete"
                                  data-type="confirm"
                                >
                                  <i className="fa fa-trash-o text-danger" />
                                </button>
                              </td>
                            </tr>
                            <tr>
                              <td>5</td>
                              <td>New Year's Day</td>
                              <td>Public Holiday</td>
                              <td>01 January 2024</td>
                              <td>03 January 2024</td>
                              <td>
                                <button
                                  type="button"
                                  className="btn btn-icon btn-sm"
                                  title="View"
                                >
                                  <i className="fa fa-eye" />
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-icon btn-sm"
                                  title="Edit"
                                >
                                  <i className="fa fa-edit" />
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-icon btn-sm js-sweetalert"
                                  title="Delete"
                                  data-type="confirm"
                                >
                                  <i className="fa fa-trash-o text-danger" />
                                </button>
                              </td>
                            </tr>
                            <tr>
                              <td>6</td>
                              <td>Memorial Day</td>
                              <td>Public Holiday</td>
                              <td>29 May 2024</td>
                              <td>29 May 2024</td>
                              <td>
                                <button
                                  type="button"
                                  className="btn btn-icon btn-sm"
                                  title="View"
                                >
                                  <i className="fa fa-eye" />
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-icon btn-sm"
                                  title="Edit"
                                >
                                  <i className="fa fa-edit" />
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-icon btn-sm js-sweetalert"
                                  title="Delete"
                                  data-type="confirm"
                                >
                                  <i className="fa fa-trash-o text-danger" />
                                </button>
                              </td>
                            </tr>
                            <tr>
                              <td>7</td>
                              <td>Christmas Day</td>
                              <td>Public Holiday</td>
                              <td>25 December 2024</td>
                              <td>03 January 2024</td>
                              <td>
                                <button
                                  type="button"
                                  className="btn btn-icon btn-sm"
                                  title="View"
                                >
                                  <i className="fa fa-eye" />
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-icon btn-sm"
                                  title="Edit"
                                >
                                  <i className="fa fa-edit" />
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-icon btn-sm js-sweetalert"
                                  title="Delete"
                                  data-type="confirm"
                                >
                                  <i className="fa fa-trash-o text-danger" />
                                </button>
                              </td>
                            </tr>
                            <tr>
                              <td>8</td>
                              <td>Annual Function</td>
                              <td>Holiday By Collage</td>
                              <td>01 March 2024</td>
                              <td>03 March 2024</td>
                              <td>
                                <button
                                  type="button"
                                  className="btn btn-icon btn-sm"
                                  title="View"
                                >
                                  <i className="fa fa-eye" />
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-icon btn-sm"
                                  title="Edit"
                                >
                                  <i className="fa fa-edit" />
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-icon btn-sm js-sweetalert"
                                  title="Delete"
                                  data-type="confirm"
                                >
                                  <i className="fa fa-trash-o text-danger" />
                                </button>
                              </td>
                            </tr>
                            <tr>
                              <td>9</td>
                              <td>New Year's Day</td>
                              <td>Public Holiday</td>
                              <td>01 January 2024</td>
                              <td>03 January 2024</td>
                              <td>
                                <button
                                  type="button"
                                  className="btn btn-icon btn-sm"
                                  title="View"
                                >
                                  <i className="fa fa-eye" />
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-icon btn-sm"
                                  title="Edit"
                                >
                                  <i className="fa fa-edit" />
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-icon btn-sm js-sweetalert"
                                  title="Delete"
                                  data-type="confirm"
                                >
                                  <i className="fa fa-trash-o text-danger" />
                                </button>
                              </td>
                            </tr>
                            <tr>
                              <td>10</td>
                              <td>Memorial Day</td>
                              <td>Public Holiday</td>
                              <td>29 May 2024</td>
                              <td>29 May 2024</td>
                              <td>
                                <button
                                  type="button"
                                  className="btn btn-icon btn-sm"
                                  title="View"
                                >
                                  <i className="fa fa-eye" />
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-icon btn-sm"
                                  title="Edit"
                                >
                                  <i className="fa fa-edit" />
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-icon btn-sm js-sweetalert"
                                  title="Delete"
                                  data-type="confirm"
                                >
                                  <i className="fa fa-trash-o text-danger" />
                                </button>
                              </td>
                            </tr>
                            <tr>
                              <td>11</td>
                              <td>Christmas Day</td>
                              <td>Public Holiday</td>
                              <td>25 December 2024</td>
                              <td>03 January 2024</td>
                              <td>
                                <button
                                  type="button"
                                  className="btn btn-icon btn-sm"
                                  title="View"
                                >
                                  <i className="fa fa-eye" />
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-icon btn-sm"
                                  title="Edit"
                                >
                                  <i className="fa fa-edit" />
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-icon btn-sm js-sweetalert"
                                  title="Delete"
                                  data-type="confirm"
                                >
                                  <i className="fa fa-trash-o text-danger" />
                                </button>
                              </td>
                            </tr>
                            <tr>
                              <td>12</td>
                              <td>Annual Function</td>
                              <td>Holiday By Collage</td>
                              <td>01 March 2024</td>
                              <td>03 March 2024</td>
                              <td>
                                <button
                                  type="button"
                                  className="btn btn-icon btn-sm"
                                  title="View"
                                >
                                  <i className="fa fa-eye" />
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-icon btn-sm"
                                  title="Edit"
                                >
                                  <i className="fa fa-edit" />
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-icon btn-sm js-sweetalert"
                                  title="Delete"
                                  data-type="confirm"
                                >
                                  <i className="fa fa-trash-o text-danger" />
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table> */}
                        <table className="table table-hover table-vcenter text-nowrap js-basic-example dataTable table-striped table_custom border-style spacing5">
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Holiday Name</th>
                              <th>Subject</th>
                              <th>Date</th>

                              <th>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {holiday.map((item, index) => (
                              <tr key={item.id}>
                                <td>{index + 1}</td>
                                <td>{item.holidayName}</td>
                                <td>Public Holiday</td>
                                <td>
                                  {new Date(
                                    item.holidayDate
                                  ).toLocaleDateString()}
                                </td>

                                <td>
                                  <span
                                    className={`badge ${
                                      item.status
                                        ? "bg-success"
                                        : "bg-secondary"
                                    }`}
                                  >
                                    {item.status ? "Active" : "Inactive"}
                                  </span>
                                  <button
                                    type="button"
                                    className="btn btn-icon btn-sm ms-2"
                                    title="View"
                                  >
                                    <i className="fa fa-eye" />
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-icon btn-sm"
                                    title="Edit"
                                  >
                                    <i className="fa fa-edit" />
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-icon btn-sm js-sweetalert"
                                    title="Delete"
                                    data-type="confirm"
                                  >
                                    <i className="fa fa-trash-o text-danger" />
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tab-pane" id="Holiday-add">
                  <div className="card">
                    <div className="card-header">
                      <h3 className="card-title">Add Holiday</h3>
                      <div className="card-options ">
                        <a
                          href="#"
                          className="card-options-collapse"
                          data-toggle="card-collapse"
                        >
                          <i className="fe fe-chevron-up" />
                        </a>
                        <a
                          href="#"
                          className="card-options-remove"
                          data-toggle="card-remove"
                        >
                          <i className="fe fe-x" />
                        </a>
                      </div>
                    </div>
                    <form className="card-body" onSubmit={handleSubmit}>
                      <div className="form-group row">
                        <label className="col-md-3 col-form-label">
                          Holiday Name <span className="text-danger">*</span>
                        </label>
                        <div className="col-md-7">
                          <input
                            type="text"
                            className="form-control"
                            name="holidayName"
                            value={formData.holidayName}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="form-group row">
                        <label className="col-md-3 col-form-label">
                          Holiday Date <span className="text-danger">*</span>
                        </label>
                        <div className="col-md-7">
                          <input
                            type="date"
                            className="form-control"
                            name="holidayDate"
                            value={formData.holidayDate}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="form-group row">
                        <label className="col-md-3 col-form-label" />
                        <div className="col-md-7">
                          <button type="submit" className="btn btn-primary">
                            Submit
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <div className="tab-pane" id="Holiday-add-Boot">
                  <div className="card">
                    <div className="card-header">
                      <h3 className="card-title">Add Library</h3>
                      <div className="card-options ">
                        <a
                          href="#"
                          className="card-options-collapse"
                          data-toggle="card-collapse"
                        >
                          <i className="fe fe-chevron-up" />
                        </a>
                        <a
                          href="#"
                          className="card-options-remove"
                          data-toggle="card-remove"
                        >
                          <i className="fe fe-x" />
                        </a>
                      </div>
                    </div>
                    {/* <form className="card-body" onSubmit={handleSubmit}>
                      <div className="form-group row">
                        <label className="col-md-3 col-form-label">
                          Holiday Name <span className="text-danger">*</span>
                        </label>
                        <div className="col-md-7">
                          <input
                            type="text"
                            className="form-control"
                            name="holidayName"
                            value={formData.holidayName}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="form-group row">
                        <label className="col-md-3 col-form-label">
                          Holiday Date <span className="text-danger">*</span>
                        </label>
                        <div className="col-md-7">
                          <input
                            type="date"
                            className="form-control"
                            name="holidayDate"
                            value={formData.holidayDate}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="form-group row">
                        <label className="col-md-3 col-form-label" />
                        <div className="col-md-7">
                          <button type="submit" className="btn btn-primary">
                            Submit
                          </button>
                          <button
                            type="reset"
                            className="btn btn-outline-secondary"
                            onClick={() =>
                              setFormData({ holidayName: "", holidayDate: "" })
                            }
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </form> */}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="section-body">
            <footer className="footer">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-6 col-sm-12">
                    Copyright © 2025{" "}
                    <a href="">
                      Technology support By - Siance Software Pvt Ltd
                    </a>
                    .
                  </div>
                  {/* <div className="col-md-6 col-sm-12 text-md-right">
                    <ul className="list-inline mb-0">
                      <li className="list-inline-item">
                        <a href="../doc/index.html">Documentation</a>
                      </li>
                      <li className="list-inline-item">
                        <a href="javascript:void(0)">FAQ</a>
                      </li>
                      <li className="list-inline-item">
                        <a
                          href="javascript:void(0)"
                          className="btn btn-outline-primary btn-sm"
                        >
                          Buy Now
                        </a>
                      </li>
                    </ul>
                  </div> */}
                </div>
              </div>
            </footer>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="addNewEvent"
        aria-hidden="true"
        style={{ display: "none" }}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">
                <strong>Add</strong> an event
              </h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-hidden="true"
              >
                ×
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="row">
                  <div className="col-md-6">
                    <label className="control-label">Event Name</label>
                    <input
                      className="form-control"
                      placeholder="Enter name"
                      type="text"
                      name="category-name"
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="control-label">Choose Event Color</label>
                    <select
                      className="form-control"
                      data-placeholder="Choose a color..."
                      name="category-color"
                    >
                      <option value="success">Success</option>
                      <option value="danger">Danger</option>
                      <option value="info">Info</option>
                      <option value="primary">Primary</option>
                      <option value="warning">Warning</option>
                    </select>
                  </div>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-success save-event"
                data-dismiss="modal"
              >
                Save
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="addDirectEvent"
        tabIndex={-1}
        role="dialog"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Add Direct Event</h4>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Event Name</label>
                    <input
                      className="form-control"
                      name="event-name"
                      type="text"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Event Type</label>
                    <select name="event-bg" className="form-control">
                      <option value="success">Success</option>
                      <option value="danger">Danger</option>
                      <option value="info">Info</option>
                      <option value="primary">Primary</option>
                      <option value="warning">Warning</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn save-btn btn-success">Save</button>
              <button className="btn btn-secondary" data-dismiss="modal">
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="eventEditModal"
        tabIndex={-1}
        role="dialog"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Edit Event</h4>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Event Name</label>
                    <input
                      className="form-control"
                      name="event-name"
                      type="text"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Event Type</label>
                    <select name="event-bg" className="form-control">
                      <option value="success">Success</option>
                      <option value="danger">Danger</option>
                      <option value="info">Info</option>
                      <option value="primary">Primary</option>
                      <option value="warning">Warning</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn mr-auto delete-btn btn-danger">
                Delete
              </button>
              <button className="btn save-btn btn-success">Save</button>
              <button className="btn btn-default" data-dismiss="modal">
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Holiday;
